import VDatePicker from './VDatePicker'
import VTimePicker from './VTimePicker'

export default {
  VDatePicker,
  VTimePicker
}



// WEBPACK FOOTER //
// ./src/components/pickers/index.js